import classnames from 'classnames'
import React from 'react'
import { APPS_ADJUST_URL } from '../../parameters'
import { TAG_BLOCK_AUTOPROMO } from '../analytics/analytics.tagids.constants'
import analyticsConstants from '../analytics/analytics.constants'
import RectangleActionButton, {
  COLOR_GREEN,
  SIZE_MEDIUM
} from '../genericComponents/buttons/RectangleActionButton'
import TagActionLink from '../genericComponents/TagActionLink'
import { withFrenchSite } from '../i18n/i18nSite'
import prefooterDevicePng from './assets/prefooter_image.png'
import prefooterDeviceWebp from './assets/prefooter_image.webp'
import s from './FooterAppAutoPromoPE.less'
import ImageWithFallback from '../ui/ImageWithFallback'

const FooterAppAutoPromoPE = ({ className }) => {
  return (
    <div className={classnames(s.wrapper, className)}>
      <div className={s.infos}>
        <ImageWithFallback
          className={s.device}
          image={prefooterDeviceWebp}
          fallbackImage={prefooterDevicePng}
          width="102"
          height="108"
        />
        <div className={s.content}>
          <div className={s.textContainer}>
            <span className={s.title}>{"Laissez vous guider par le GPS de l'application Mappy"}</span>
            <span className={s.text}>{'Info trafic, alertes de vitesse et radars'}</span>
          </div>
          <div>
            <TagActionLink
              href={APPS_ADJUST_URL}
              nofollow={true}
              targetBlank={true}
              type={TAG_BLOCK_AUTOPROMO}
              tagInfo={{
                area: analyticsConstants.autopromo.area.main
              }}
            >
              <RectangleActionButton label={"Installer l'App"} color={COLOR_GREEN} size={SIZE_MEDIUM} />
            </TagActionLink>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withFrenchSite(FooterAppAutoPromoPE)
